<template>
<v-container fluid>
  <!-- メインコンテンツ -->
  <v-row no-gutters>
    <v-col cols="12">
      <v-card>
        <!-- 作業日報タイトル -->
        <v-card-title>作業日報</v-card-title>
        <!-- 作業日 -->
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="2">
              <v-text-field label="作業日" v-model="constructionDateSlash" prepend-inner-icon="mdi-calendar-month" dense outlined readonly/>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- 一覧部 -->
        <custom-data-table class="mb-3" :header="reportHeaders" :items="reportItems" :loading="loading">
          <template v-slot:action_worker_content="{ item }">
            <v-btn class="my-2" depressed small color="info" @click.stop="showWorkerContentReferenceDialog(item.tabIndex)">作業内容参照</v-btn>
          </template>
          <template v-slot:action="{ item }">
            <v-btn class="my-2 d-flex" depressed small color="primary" :to="{ name: 'WorkerDailyReportBusinessTripInfo', params: { id: item.id, worker_date: constructionDateSlash, user_id: prmUserId, referrer: 'approval' } }">出張等</v-btn>
            <v-btn class="my-2 d-flex" depressed small color="primary" :to="{ name: 'WorkerDailyReportExpenseInfo', params: { id: item.id, worker_date: constructionDateSlash, user_id: prmUserId, referrer: 'approval' } }" :disabled="item.construction_type_name == null">経費等</v-btn>
          </template>
        </custom-data-table>
        <!-- アクション -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" :to="{ name: 'WorkerDailyReportComform' }">戻る</v-btn>
          <v-btn depressed color="error" @click.prevent="approval(2)">差し戻し</v-btn>
          <v-btn depressed color="success" @click.prevent="approval(3)">承認</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>

  <!-- 作業内容参照ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="workerContentReferenceDialogDrawer" persistent max-width="700">
      <v-card>
        <v-card-title class="headline">作業内容参照</v-card-title>
        <v-card-text v-if="tabLength > 0">
          <v-toolbar color="accent" dark flat dense><v-toolbar-title>{{ this.tabDataList[this.selectTab].tabName }}</v-toolbar-title></v-toolbar>
          <v-row>
            <v-col cols="2"><header>工事名</header></v-col>
            <v-col cols="10"><header>{{ this.tabDataList[this.selectTab].constructionName }}</header></v-col>
          </v-row>
          <v-divider/>
          <v-row>
            <v-col cols="2"><header>作業内容</header></v-col>
            <v-col cols="10"><header style="white-space:pre-wrap; word-wrap:break-word;">{{ this.tabDataList[this.selectTab].workerContent }}</header></v-col>
          </v-row>
          <v-divider/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" @click.stop="workerContentReferenceDialogDrawer = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</v-container>
</template>


<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import WorkerDailyReportSubApi from "@/api/worker-daily-report-sub-api";
import CustomDataTable from "@/components/custom_ui/CustomDataTable2";
export default {
  name: "WorkerDailyReportApproval",
  components: {
    CustomDataTable,
  },
  data: () => ({
    loading: false,
    // 画面引数
    prmUserId: null,
    prmWorkerDate: "",
    // ------------------------
    // 一覧データ表示用リスト
    // ------------------------
    reportHeaders: [
      { text: "No", value: "no" },
      { text: "工番", value: "construction_number", bottomText: "工事名", bottomValue: "construction_name" },
      { text: "工種", value: "construction_type_name", bottomText: "作業項目", bottomValue: "work_item_name" },
      { text: "開始時間", value: "start_work_time", bottomText: "終了時間", bottomValue: "end_work_time" },
      { text: "休憩時間", value: "worker_break_time" },
      { text: "残業開始", value: "start_over_time", bottomText: "残業終了", bottomValue: "end_over_time" },
      { text: "残業時休憩時間", value: "worker_over_break_time" },
      { text: "作業内容", value: "action_worker_content" },
      { text: "アクション", value: "action" }
    ],
    reportItems: [],

    // ------------------------
    // 共通
    // ------------------------
    // 作業日
    constructionDate: "",
    constructionDateSlash: "",
    // 作業報告データリスト
    tabDataList: {},
    // 作業報告IDリスト
    tabIdList: {},
    tabLength: 0,
    selectTab: null,

    // ------------------------
    // 作業内容参照ダイアログ
    // ------------------------
    workerContentReferenceDialogDrawer: false
  }),
  created () {
    this.initialize();
  },
  methods: {
    initialize() {
      this.isLoading();
      // 画面引数をセット
      this.prmUserId = this.$route.params.user_id;
      this.prmWorkerDate = this.$route.params.worker_date;
      this.constructionDate = this.parseDate(this.prmWorkerDate);
      this.constructionDateSlash = this.prmWorkerDate;
      this.workerDailyReportSubApi = new WorkerDailyReportSubApi();
      // 作業日報を取得
      const promise = this.workerDailyReportSubApi.info(this.constructionDate, this.prmUserId);
      promise.then((response) => {
        // 作業日報
        for (let item of response.data.body.worker_daily_report_info) {
          this.tabLength++;
          this.selectTab = 'tab-' + this.tabLength;
          this.tabDataList[this.selectTab] = item.report;
          this.tabIdList[this.selectTab] = { id: item.id };
        }
        if (this.tabLength > 0) {
          this.selectTab = 'tab-1';
        }
        // 画面用バッファへ反映
        this.refreshDisplay();
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error", error.response.data.message);
            this.$router.push({ name: "WorkerDailyReport" });
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    // ---------------------------------------------
    // 表示用バッファへ反映
    // ---------------------------------------------
    refreshDisplay() {
      this.reportItems = [];
      let idx = 0;
      for (let index in this.tabDataList) {
        idx++;
        let item = this.tabDataList[index];
        let constructionType = null;
        if (item.constructionType != null) {
          constructionType = item.constructionType;
        }
        let itemId = this.tabIdList[index];
        this.reportItems.push({
          id: itemId.id,
          tabIndex: index,
          no: idx,
          construction_number: item.constructionNumber,
          construction_name: item.constructionName,
          construction_type_name: constructionType.name,
          work_item_name: item.workItem == null ? null : item.workItem.name,
          start_work_time: item.startWorkerTime,
          end_work_time: item.endWorkerTime,
          worker_break_time: this.formatDispTime(item.workerBreakHourTime, item.workerBreakMinuteTime),
          start_over_time: item.startOverTime,
          end_over_time: item.endOverTime,
          worker_over_break_time: this.formatDispTime(item.overBreakHourTime, item.overBreakMinuteTime),
          worker_content: item.workerContent
        });
      }
    },

    // ---------------------------------------------
    // -- メインコンテンツ
    // ---------------------------------------------
    // ---------------------------------------------
    // イベント処理「作業内容参照」ボタン押下
    // ---------------------------------------------
    showWorkerContentReferenceDialog(tabIndex) {
      this.selectTab = tabIndex;
      this.workerContentReferenceDialogDrawer = true;
    },

    // ---------------------------------------------
    // -- その他処理
    // ---------------------------------------------
    // ローディング表示・非表示
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    // 日付フォーマット
    parseDate(date) {
      if (!date) return null;
      const [year,month, day] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    // -----------------------------------------------------
    // 表示時間フォーマット
    // -----------------------------------------------------
    formatDispTime(hour, minute) {
      let retStr = '';
      if (hour > 0) {
        retStr = hour + '時間';
      }
      if (minute > 0) {
        retStr += minute + '分';
      }
      if (!retStr) {
        retStr = '0分';
      }
      return retStr;
    },

    // ------------------------
    // 承認/差し戻し
    // ------------------------
    approval (status) {
      this.isLoading();
      const promise = this.workerDailyReportSubApi.updateStatus(this.constructionDate, this.prmUserId, status);
      promise.then((response) => {
        this.$emit('success', response.data.message);
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else {
            this.$emit("error",error.response.data.message);
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
        this.$router.push({ name: 'WorkerDailyReportComform' });
      });
    },
  }
}
</script>
